import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import InvoiceTypeForm from '../../../components/forms/InvoiceTypeForm';
import { useInvoiceTypeApi } from '../../../hooks/useInvoiceTypeApi';
import { useNavigate } from 'react-router-dom';
import { InvoiceTypeDTO } from '../../../services/apiClient';

const InvoiceTypeCreate: React.FC = () => {
  const { create, isLoading } = useInvoiceTypeApi();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Invoice Types', href: '/admin/invoicetypes' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: InvoiceTypeDTO) => {
    try {
      setIsSubmitting(true);
      await create(data);
      navigate('/admin/invoicetypes');
    } catch (error) {
      console.error('Error creating InvoiceType:', error);
    } finally{
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/invoicetypes"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.InvoiceType.Edit'
    >
        <InvoiceTypeForm
          initialValues={{} as InvoiceTypeDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/invoicetypes')}
          isLoading={isSubmitting}
        />
    </AdminLayout>
  );
};

export default InvoiceTypeCreate;